import { CommonService } from './../../services/common.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import { MyoderService } from '../shared/myoder.service';
import { Order } from '../../models/orders.model';
import { OrderItem } from '../../models/orders.model';
import { sortingInfo } from '../../models/filter.model';
import { Sort } from '@angular/material/sort';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { ManageService } from '../../services/manage.service';
import { FileService } from '../../services/file.service';
import {filter, takeUntil} from 'rxjs/operators';
import { NgProgressService } from '../../services/ngProgress.service';


@Component({
  selector: 'app-open-orders',
  templateUrl: './open-orders.component.html',
  styleUrls: ['./open-orders.component.css']
})
export class OpenOrdersComponent implements OnInit, OnDestroy {

  title = 'Open Orders';
  orders: Order[];
  sortedData: Order[];
  items: OrderItem[];  // Items
  hasEmptyFilterResult = false; // checking the return value by calling filter pipe
  filterInput: string; // binds to ngModel of filter input
  loadContent = false;
  showResultDownloading = false;
  sortingInfoObj: sortingInfo = {
    comparedProperty: '',
    sortingOrder: ''
  };

  filterResultArr: any;
 
  ngUnsubscribe: Subject<void> = new Subject<void>();
  narrow: boolean = false;
  selectedOrder = '';
  constructor(
    private router: Router,
    private orderService: MyoderService,
    private activatedRouter: ActivatedRoute,
    private manageService: ManageService,
    private fileService: FileService,
    public ngProgress: NgProgressService,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {
    this.loadContent = false;
    const url = this.router.url;
    const urlArray = url.split('/');

    if (urlArray[urlArray.length - 1] !== 'openorders') {
      this.loadContent = true;  // set to true to avoid load two loading screen at the same time
    }
    if (['/myOrder/openorders', '/myAccount/openorders'].includes(url)) {
      this.narrow = false;
    } else {
      this.narrow = true;
    }
    this.orderService.currentPaymentWatch.subscribe(res => {
      this.loadOrders();
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

    if (url.includes("myOrder")) {
      this.commonService.emitUpdateSideBarActiveItem('orders');
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      if (this.router.url === '/myOrder/openorders' || this.router.url == '/myAccount/openorders') {
        $('#levelOne').animate({ scrollLeft: -250 }, 400);
        this.narrow = false;
      }else{
        this.narrow = true;
      }

    });
  }

  goOrderDetail(order: Order) {
    this.router.navigate(['orderitemdetail', order.orderNo + order.orderSuffix], {relativeTo: this.activatedRouter});
    this.selectedOrder = `${order.orderNo}${order.orderSuffix}` ;
  }
  exportOrderSerials(orderNumber: string, orderSuffix: string) {
    this.orderService.exportExportOrderSerials(orderNumber, orderSuffix)
    .subscribe(data => {
      const fileName = `DD_OrderSerials_${orderNumber}.xlsx`;
        this.fileService.saveAsExcelFile(data, fileName);
    },
    (error: any) => {
      console.error(error);
    });
  }
  loadOrders() {
    this.loadContent = false;
    this.orderService.getOpenOrders().pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: Order[]) => {
        this.orderService.openOrders$.next(value);       
        this.orders = value;       
        this.orders.map(element => {
          element.totalEx = element.totalEx.replace('-', '').trim();
        });     
        this.sortedData = this.orders.slice();       
        this.sortedData.map(order => {
          order.showPayNowBtn = false;
          const totalEx = order.totalEx.replace(/,/g, '');
          if (!order.isCreditAccount && Number(totalEx) > 0 && (Number(totalEx) > Number(order.prePaidAmount))) {
            order.showPayNowBtn = true;
          }
        });
        this.loadContent = true;
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        }
      );
  }

  ngOnDestroy() {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  checkDocumentAvailability(order: Order) {
    if (order.orderConfirmationUrl || order.creditNoteUrl || order.deliveryDocketUrl || order.invoiceUrl || order.licenceAgreeUrl || order.orderAmendUrl) {
      return true;
    } else {
      return false;
    }
  }

  sortByDescendAscend(comparedProperty: string, sortingOrder: string) {
    switch (comparedProperty) {
      case 'orderNo':
        this.sortingInfoObj.comparedProperty = 'orderNo';
        break;
      // --------------------------------------------------------------------------------------
      case 'orderDate':
        this.sortingInfoObj.comparedProperty = 'dateOrdered';
        break;
      // --------------------------------------------------------------------------------------
      case 'resellerPo':
        this.sortingInfoObj.comparedProperty = 'resellerPO';
        break;
      // --------------------------------------------------------------------------------------
      case 'orderStatus':
        this.sortingInfoObj.comparedProperty = 'orderStatus';
        break;
      // --------------------------------------------------------------------------------------
      case 'holdReason':
        this.sortingInfoObj.comparedProperty = 'holdReasonDescription';
        break;
      // --------------------------------------------------------------------------------------
      case 'totalEx':
        this.sortingInfoObj.comparedProperty = 'totalEx';
        break;
    }

    if (sortingOrder === 'descending') {
      this.sortingInfoObj.sortingOrder = 'descending';
    } else {
      this.sortingInfoObj.sortingOrder = 'ascending';
    }
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.orders, ['orderNo', 'dateOrdered', 'resellerPO', 'orderStatus', 'holdReasonDescription'], this.filterInput);
    if (this.filterResultArr.length === 0) {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.filterInput = '';
    this.hasEmptyFilterResult = false;
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  sortData(sort: Sort) {
    const data = this.orders.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'orderNo': return compare(a.orderNo, b.orderNo, isAsc);
        case 'orderDate': return compare(a.dateOrdered.split('-').reverse().join('-'), b.dateOrdered.split('-').reverse().join('-'), isAsc);
        case 'resellerPo': return compare(a.resellerPO, b.resellerPO, isAsc);
        case 'orderStatus': return compare(a.orderStatus, b.orderStatus, isAsc);
        case 'holdReason': return compare(a.holdReasonDescription, b.holdReasonDescription, isAsc);
        case 'totalEx': return compare(parseFloat(a.totalEx), parseFloat(b.totalEx), isAsc);
        default: return 0;
      }
    });
  }

  exportExcelForOpenOrder(): void {
    this.ngProgress.start();
    if(this.showResultDownloading) {
      return;
    }
    this.showResultDownloading = true;
    this.manageService.ExportOpenOrdersLink().subscribe((res: any) => {
      const downloadURL = window.location.origin + res;
      window.location.href = downloadURL;
      this.ngProgress.done();
      this.showResultDownloading = false;
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
        this.showResultDownloading = false;
      });
  }

  ExportOpenOrderLink() {
    if(this.showResultDownloading) {
      return;
    }
    this.showResultDownloading = true;
    this.manageService.ExportOpenOrdersLink().subscribe((res: string) => {
      if (res) {
        console.log(res);
        const downloadURL = window.location.origin + res;
        this.copyToClipboard(downloadURL);
        this.commonService.implementToast('Open Orders download link copied to clipboard successfully', 'Success');
        this.showResultDownloading = false;
      }
    },
      (error: any) => {
        console.error(error);
        this.commonService.implementToast('Get Open Orders download url failed', 'Error');
        this.showResultDownloading = false;
      });
  }

  copyToClipboard(item: any): void {
    const listener = (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', (item));
      e.preventDefault();
    };

    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  payOrder(order: Order): void {
    this.router.navigate(['payment'], {
      relativeTo: this.activatedRouter,
      queryParams: {
        orderNumber: order.orderNo,
        paymentFor: 'order',
        orderSuffix: order.orderSuffix
      },
      skipLocationChange: true
    });
  }

  close() {
    if (this.router.url === `/myAccount/openorders`) {
      this.router.navigateByUrl('/myAccount');
    } else {
      this.router.navigateByUrl('/myOrder');
      if (this.narrow) {
        $('#levelOne').animate(
          { scrollLeft: (-252) },
          {
            duration: 400,
            complete: function () {
              $('.combination-loader').stop(true, false);
            }
          });
      }
    }
  }

  convertTotal(total: string): number {
    return parseFloat(total.includes('-') ? total.replace('-', '') : total);
  }
  // onActivate(paymentComplete) {
  //   debugger;
  //   paymentComplete.refreshOpenOrders.subscribe((data) => {
  //       // Will receive the data from child here
  //       if (data) {
  //          this.loadOrders();
  //       }
  //   })
  // }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
